
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContentPasteGoogle as ObiContentPasteGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-content-paste-google.js';
 
 
 

 
 export const ObiContentPasteGoogle = createComponent({
   react: React,
   tagName: 'obi-content-paste-google',
   elementClass: ObiContentPasteGoogleElement,
   events: {
     
   }
  });
 
 